/**
 * @file 検索ボックスアコーディオン
 */
'use strict';


/**
 * @classname AnchorSearchAccordion
 * @classdesc 検索ボックスアコーディオン
 */
export default class AnchorSearchAccordion {
	/**
	 * @constructor
	 * @param {object} controller - controller オブジェクト
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('AnchorSearchAccordion.constructor');
		this._$e = $e;
		this._$target = $e.closest('.block--search-condition').find('> .block__item');
		$e.on('click', () => this.onClick());
    };


	/**
	 * clickのコールバック
	 *
	 * @memberof AnchorSearchAccordion
	 * @return {undefined}
	 */
    onClick() {
		console.log('AnchorSearchAccordion.onClick');
		if(this._$e.hasClass('close')){
		    this._$e.removeClass('close');
            this._$target.slideDown();
        }else{
            this._$e.addClass('close');
            this._$target.slideUp();
        }
	};
}
